import React from 'react';
import Heading from '@atlaskit/heading';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

export const Header = () => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={headerWrapperStyles}>
			<Heading size="small" as="h2">
				{formatMessage(messages.subTitleNonFinal)}
			</Heading>
		</Box>
	);
};

const headerWrapperStyles = xcss({
	paddingTop: 'space.0',
	paddingBottom: 'space.0',
	width: '100%',
});
